import { render } from "./MainDataOrganizations.vue?vue&type=template&id=16b41d14"
import script from "./MainDataOrganizations.vue?vue&type=script&lang=js"
export * from "./MainDataOrganizations.vue?vue&type=script&lang=js"

import "./MainDataOrganizations.vue?vue&type=style&index=0&id=16b41d14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__